import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Careers from "./pages/Careers/Careers";
import Contact from "./pages/Contact/Contact";
import Awards from "./pages/Awards/Awards";
import ChannelPartners from "./pages/ChannelPartners/ChannelPartners";
import ScrollToTop from "components/ScrollToTop/ScrollToTop";
import ImpactsOfBadDebt from "pages/Blogs/ImpactsOfBadDebt/ImpactsOfBadDebt";
import Guidelines from "pages/Blogs/Guidelines/Guidelines";
import WhatsAppButton from "components/WhatAppButton/WhatsAppButton";

function App() {
  useEffect(() => {
    AOS.init({ duration: 700, easing: "ease-out-cubic", once: true, offset: 60 });
  }, []);

  return (
    <Router basename={process.env.REACT_APP_BASE_PATH}>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/awards-and-recognitions" element={<Awards />} />
          <Route path="/channel-partners" element={<ChannelPartners />} />
          <Route path="/impacts-of-bad-debt" element={<ImpactsOfBadDebt />} />
          <Route path="/guidelines-for-default-loan-recovery" element={<Guidelines />} />
        </Routes>
      </main>
      <WhatsAppButton phone="919008328891" text="Chat with us" />
      <Footer />
    </Router>
  );
}

export default App;
